import { render } from "./ProgramSelector.vue?vue&type=template&id=1b1cc762&scoped=true"
import script from "./ProgramSelector.vue?vue&type=script&lang=js"
export * from "./ProgramSelector.vue?vue&type=script&lang=js"

import "./ProgramSelector.vue?vue&type=style&index=0&id=1b1cc762&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1cc762"]])

export default __exports__